module.exports = __webpack_public_path__ + "static/media/lifestyle4-small.64ab9aa2.jpg";